import useFeatures from "@casino/legacy/client/hooks/feature/useFeatures";
import { getCookie } from "@workspace/cookies/browser";

const useFeature = <T extends Feature>(flag: T) => {
  const features = useFeatures();
  const overrideCookie = getCookie(`override_ff_${flag}`);

  if (!features) {
    return undefined;
  }

  return overrideCookie === undefined || overrideCookie === ""
    ? features[flag]
    : overrideCookie === "true";
};

export default useFeature;
